import './ListPostings.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import classNames from "classnames";

import { clearOpportunity, deleteOpportunity, getOpportunitiesForCompany, setOpportunity } from 'containers/Opportunities/store/actions';

import A from 'components/A';
import Button from 'components/Button';
import CircleIcon from 'components/CircleIcon';
import ConfirmModal from 'components/Modal/ConfirmModal';
import H1 from 'components/H1';
import H2 from 'components/H2';
import LoadingCircle from 'components/LoadingCircle';
import Nav from 'components/Nav';
import NavItem from 'components/NavItem';
import OpportunityMetadata from 'containers/Opportunities/components/OpportunityMetadata';
import PageContent from 'components/PageContent';

class ListPostings extends React.Component {
    constructor() {
        super();

        this.tabs = ['published', 'drafts'/*, 'fulfilled'*/];

        this.state = {
            showConfirmDeleteModal: false
        }
    }

    componentWillMount() {
        document.body.classList.add('list-postings-page');

        if(this.props.auth.user.id != null && this.props.auth.user.company == null) {
            this.props.changeLocation('/account/profile');
        } else if(this.props.auth.user.company != null) {
            this.props.getOpportunitiesForCompany(this.props.auth.user.company.id);
        }

    }

    componentWillUnmount() {
        document.body.classList.remove('list-postings-page');
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.auth.user.id !== nextProps.auth.user.id) {
            if(nextProps.auth.user.company == null) {
                this.props.changeLocation('/account/profile');
            } else {
                this.props.getOpportunitiesForCompany(this.props.auth.user.company.id);
            }
        }
    }

    confirmDelete(posting) {
        this.props.setOpportunity(posting);
        this.setState({showConfirmDeleteModal: true});
    }

    generatePosting(posting, index) {
        return (
            <li className="list-postings__posting" key={index}>
                <header className="list-postings__posting-header">
                    <A to={`/opportunity/${posting.id}`}>
                        <H2>
                            {posting.title}
                        </H2>
                    </A>
                    <OpportunityMetadata
                        duration={posting.duration}
                        location={posting.company.location != null ? posting.company.location.name : 'Remote'}
                        startDate={posting.startDate}
                    />
                </header>
                <div className="list-postings__posting-actions">
                    <A to={`/posting/${posting.id}`}>
                        <CircleIcon type="edit" />
                    </A>
                    <Button noStyles
                            onClick={this.confirmDelete.bind(this, posting)}>
                        <CircleIcon type="delete" />
                    </Button>
                </div>

                <div className="list-postings__posting-description">
                    {posting.summary}
                </div>
            </li>
        );
    }

    _handleDelete() {
        this.props.deleteOpportunity()
            .then((res) => {
                this.props.getOpportunitiesForCompany(this.props.auth.user.company.id, true)
                    .then(() => {
                        this.setState({showConfirmDeleteModal: false});
                    });
            })
    }

    render() {
        let { opportunities } = this.props.opportunities;

        let urlTab = this.props.params.tab;

        return (
            <PageContent className="list-postings">
                <header className="list-postings__header">
                    <H1>
                        Job Postings
                    </H1>
                    <A className="c-button" to="/posting/new">
                        Create New Job Posting
                    </A>
                </header>

                {this.props.opportunities.isFetching === true ? (
                    <LoadingCircle />
                ) : (
                    <div>
                        <Nav className="postings__nav">
                            <ul className="c-nav__menu postings__menu">
                                {this.tabs.map((tab, index) => {
                                    return (
                                        <NavItem key={index}>
                                            <A className={classNames('postings__tab', {'a-nav-item__link--active': tab === urlTab})}
                                               to={`/postings/${tab}`}>
                                                {tab} ({opportunities[tab] ? opportunities[tab].length : 0})
                                            </A>
                                        </NavItem>
                                    )
                                })}
                            </ul>
                        </Nav>

                        <section className="list-postings__lists-wrapper">
                            {urlTab === 'published' ? (
                                <ul className="list-postings__list">
                                    {opportunities.published.map((posting, index) => this.generatePosting(posting, index))}
                                </ul>
                            ) : null}

                            {urlTab === 'drafts' ? (
                                <ul className="list-postings__list">
                                    {opportunities.drafts.map((posting, index) => this.generatePosting(posting, index))}
                                </ul>
                            ) : null}

                            {/*{urlTab === 'fulfilled' ? (
                                <ul className="list-postings__list">
                                    {['a', 'a', 'a', 'a', 'a', 'a', 'a', 'a', 'a'].map((posting, index) => this.generatePosting(posting, index))}
                                </ul>
                            ) : null}*/}
                        </section>
                    </div>
                )}

                <ConfirmModal
                    content="This action cannot be undone."
                    confirmOnClick={this._handleDelete.bind(this)}
                    confirmText={(
                        <span>
                            Delete
                            {this.props.opportunities.isDeleting === true || this.props.opportunities.isFetching === true ? (
                                <LoadingCircle />
                            ) : null}
                            </span>
                    )}
                    declineOnClick={() => {
                        this.setState({showConfirmDeleteModal: false});
                        this.props.clearOpportunity();
                    }}
                    declineText="Cancel"
                    show={this.state.showConfirmDeleteModal === true}
                    title={`Are you sure you want to delete ${this.props.opportunities.opportunity.title}?`}
                />
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        opportunities: state.opportunities
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearOpportunity: () => dispatch(clearOpportunity()),
        deleteOpportunity: () => dispatch(deleteOpportunity()),
        getOpportunitiesForCompany: (companyId, hideSpinner) => dispatch(getOpportunitiesForCompany(companyId, hideSpinner)),
        setOpportunity: (opportunityObj) => dispatch(setOpportunity(opportunityObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListPostings);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/ListPostings/index.js